import type { VariantProps } from 'class-variance-authority'
import { useLogin } from '~/@pages_auth/login/login-form/useLogin'
import { cn } from '~/shadcn/lib/utils'
import { Button } from '~/shadcn/ui/button/button'
import type { buttonVariants } from '~/shadcn/ui/button/buttonVariants'

function LogoutButton({
  className,
  ...props
}: React.ComponentProps<'button'> &
  VariantProps<typeof buttonVariants> & {
    asChild?: boolean
  }) {
  const { logoutUser } = useLogin()
  return (
    <Button
      onClick={logoutUser}
      className={cn('lg:w-full px-5', className)}
      {...props}>
      Odhlásiť sa
    </Button>
  )
}

export { LogoutButton }
